module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture10-3ef70645baf2e4630595eed85f5b2e32.jpg";